<template>
  <div class='editor'>
    <vue-ueditor-wrap v-model="msg" :config="editorConfig" editor-id="editorInch"
      @before-init="addCustomButton"></vue-ueditor-wrap>
  </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'; // ES6 Module
export default {
  name: 'ueditor',
  components: {
    VueUeditorWrap
  },
  props: ['nr', 'addtings'],
  watch: {
    msg (newval, oldval) {
      //console.log(newval == oldval)
      // console.log(newval,oldval,'------>')

      if (newval) {
        this.$emit("editorContent", newval);
      }

    },
    nr (newval, oldval) {

      var that = this
      // this.msg = newval
      setTimeout(function () {
        that.$set(that, 'msg', newval)
      }, 200)
    },
    addtings (newval, oldval) {
      console.log(newval, oldval)
      var editor
      var html = ''
      if (newval['filetype'] == '0') {
        html = '<center><img src="' + newval.url + '"></center>';

      } else if (newval['filetype'] == '2') {
        //console.log(newval,'newval')
        var url = newval.url.split('&')
        html = '<center><video id="myvideo" poster="' + url[0] + '" width="100%" height="auto" src="' + url[1] + '" controls="controls" style="display:inline;"><source id="tv"  src="' + newval.url + '">视频</source>您的浏览器不支持video标签</video></center>';

      } else if (newval['filetype'] == '1') {
        html = '<center><audio src="' + newval.url + '" controls="controls"></audio></center>'

      } else if (newval['filetype'] == '-1') {
        html = ''
      } else if (newval['filetype'] == '6') {
        console.log(newval.url)
        var str = '<section style="padding:0px 10px;border:1px solid rgba(221, 221, 221, 1)"><section class="slideshow-container"  style="width: 100%; overflow-x: scroll; white-space: nowrap; -webkit-overflow-scrolling: touch;">'
        newval.url.map(function (val, index) {
          str += '<section class="slide" style="display: inline-block; vertical-align: top; width: 100%; height: 100%;"> <img src="' + val.url + '" alt="Image 1" style="width: 100%; height: auto;"></section>'
        })
        str += '</section><footer style="text-align:center;line-height:15px;font-size:13px;color: #252525;margin:10px 0px;">滑动查看</footer><section>';
        console.log(str)
        html = str

      } else if (newval['filetype'] == 4) {
        html = '<center><a href="' + newval.url + '" >' + newval.name + '</a></center>'
      }
      // this.msg = this.msg + html

      window.UE.getEditor('editorInch').focus();
      window.UE.getEditor('editorInch').execCommand('insertHtml', html);

      // var _html = window.UE.getEditor('editorInch').getContent()
      // //console.log(_html)
      this.$emit("editorContent", this.msg);


      // this.editor.txt.html(newval)
      // var editor = this.editor;
      // let html = `<center><audio src="http://139.196.217.92:9208/Upload/others/20220924/20220924114628_788.mp3" controls="controls"></audio></center>`;
      // editor.cmd.do('insertHTML', html);
    },
  },
  data () {
    return {
      msg: '',
      editor: 'editorInch',
      editorConfig: {
        // 访问 UEditor 静态资源的根路径，可参考 https://hc199421.gitee.io/vue-ueditor-wrap/#/faq
        UEDITOR_HOME_URL: "/UEditor/",
        // 服务端接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: "http://app.wjdaily.com:9987/UploadImageServlet",
        uploadUrl: 'http://app.wjdaily.com:9987/UploadImageServlet',
        initialFrameHeight: 820,
        initialFrameWidth: '100%',
        autoHeightEnabled: false,
        catchRemoteImageEnable: true,
        zIndex: 2000,
        token: 'Bearer ' + localStorage.getItem('access_token'),
      },
    }
  },
  mounted () {
    //console.log(VueUeditorWrap)

  },
  methods: {
    addCustomButton (editorId) {
      var that = this
      window.UE.registerUI(
        'my-custom-button',
        (editor, uiName) => {
          // 注册按钮执行时的 command 命令，使用命令默认就会带有回退操作
          editor.registerCommand(uiName, {
            execCommand () {
              // editor.execCommand('inserthtml', `<span>这是一段由自定义按钮添加的文字</span>`);
              //console.log(123)
              that.$emit('clicktool', 0)
            },

          });
          // 创建一个 button
          const btn = new window.UE.ui.Button({
            // 按钮的名字
            name: uiName,
            // 提示
            title: '插入媒体（图片、视频、音频、pdf文档）',
            // 需要添加的额外样式，可指定 icon 图标
            cssRules: `background-position:275px 45px;`,
            // 点击时执行的命令
            onclick () {
              // 这里可以不用执行命令，做你自己的操作也可
              //console.log(uiName)
              editor.execCommand(uiName);
            },
          });

          // 当点到编辑内容上时，按钮要做的状态反射
          editor.addListener('selectionchange', function () {
            const state = editor.queryCommandState(uiName);
            if (state === -1) {
              btn.setDisabled(true);
              btn.setChecked(false);
            } else {
              btn.setDisabled(false);
              btn.setChecked(state);
            }
          });

          // 因为你是添加 button，所以需要返回这个 button
          return btn;
        },
        0 /* 指定添加到工具栏上的哪个位置，默认时追加到最后 */,
        editorId /* 指定这个 UI 是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */
      );

    },
  },
}

</script>

<style>
.editor {
  width: 100%;
  height: 820px;
}
</style>
